import { CurrencySelector } from "./currencySelector";
import { DonationForm } from "../donation/donationForm";
import { PledgeRadio, PledgeCurrencyAmount } from "./pledgeRadio";
import { onCurrencySelected, updatePledgeAmounts, afterAmountUpdate } from "./donationAmountHelper";
import { StripePaymentElement } from "../stripe/stripePaymentElement";
import { translateText } from "../internationalization";

export class MultiPledgeRadioWithCurrencyComponent {
    donationForm;
    currencySelector;
    handleOtherAmount = [];
    handles = new Map();
    paymentElement;
    currencyCode;
    pledgeCurrencyAmount;
    programsAmounts = {};
  
    constructor(donationForm, currencySelectorEl, pledgeCurrencyAmount, currencyCode = "USD", paymentElement = null) {
        this.donationForm = donationForm instanceof DonationForm ? donationForm : null; 
        if (this.donationForm) {
          this.donationForm.donationType = 'pledge';
        }
        this.paymentElement = paymentElement instanceof StripePaymentElement ? paymentElement : null;
        this.currencyCode = currencyCode;
        this.pledgeCurrencyAmount = pledgeCurrencyAmount;
        this.currencySelector = currencySelectorEl ? new CurrencySelector(currencySelectorEl, this.donationForm?.defaultCurrency || currencyCode) : undefined;

        if (Array.isArray(pledgeCurrencyAmount)) {
          pledgeCurrencyAmount.forEach((pcaEl) => {

            let pca = new PledgeCurrencyAmount(pcaEl.handleOtherAmountEl, pcaEl.pledgeRadioEl, currencySelectorEl.selectCurrencyId);
            if (pca instanceof PledgeCurrencyAmount) {
              const programName = pca.pledgeRadio?.amountRadioNames;
              const handle = new PledgeRadio(this.donationForm, pca, currencyCode);
              this.handles.set(programName, handle);
              if (pca.handleOtherAmount) {
                this.handleOtherAmount.push(pca.handleOtherAmount);
                if (this.currencySelector?.selectCurrency) {
                  pca.handleOtherAmount.currencyInputEl = this.currencySelector.selectCurrency;
                  if (pca.handleOtherAmount.sufix) {
                    const curr = this.currencySelector.defaultCurrency || currencyCode;
                    pca.handleOtherAmount.sufix.textContent = curr === "USD" ? "$" : `${curr} `;
                  }
                }
              }
              this.programsAmounts[programName] = {
                value: 0,
                usdValue: 0,
                pledgeText: "",
                isSelected: false
              };
            }
          });
        } else {//if (pledgeCurrencyAmount instanceof PledgeCurrencyAmount) {
          this.pledgeCurrencyAmount = new PledgeCurrencyAmount(pledgeCurrencyAmount.handleOtherAmountEl, pledgeCurrencyAmount.pledgeRadioEl, currencySelectorEl.selectCurrencyId);
          const programName = pledgeCurrencyAmount.pledgeRadio?.amountRadioNames || "default";
          const handle = new PledgeRadio(this.donationForm, pledgeCurrencyAmount, currencyCode);
          this.handles.set(programName, handle);
          if (pledgeCurrencyAmount.handleOtherAmount) {
            this.handleOtherAmount.push(pledgeCurrencyAmount.handleOtherAmount);
          }
          this.programsAmounts[programName] = {
            value: 0,
            usdValue: 0,
            pledgeText: "",
            isSelected: false
          };
        }
    
        this.createCallbacks();
    }

    createCallbacks() {
      this.donationForm.saveFormInStorage("currency_code", this.currencySelector?.defaultCurrency ?? this.currencyCode ?? "USD");
      this.createHandlesCallbacks();
      if (this.currencySelector) {
        this.createCurrencyCallbacks();
      }
    }
  
    createHandlesCallbacks() {
      this.handles.forEach((handle, programName) => {
        handle.isMultiPledge = true;
        handle.amountRadioNames = programName;

        handle.onAmountSelected = (value, usdValue, pledgeText) => {
          this.updateProgramAmount(programName, value, usdValue, pledgeText, false);
        };

        if (handle.otherAmountInput) {
          handle.otherAmountInput.onOtherAmountUpdate = (value, usdValue) => {
            this.updateProgramAmount(programName, value, usdValue, "", true);
          };
        }
      });
    }

    getDefaultPledgeText(programName) {
      if (programName === "OBT") {
        return "to support Oral Bible Translation (OBT)";
      }
      if (programName === "BLP") {
        return "to support Bible Listening Programme (BLP)";
      }
      return `to support ${programName}`;
    }

    updateProgramAmount(programName, value, usdValue, pledgeText = "", isOther = false) {
      const numValue = parseFloat(String(value || 0).replaceAll(',', '')) || 0;
      const numUsd = parseFloat(String(usdValue || 0).replaceAll(',', '')) || 0;

      let text = (pledgeText || "").trim();
      if (!text && numValue > 0) {
        text = this.getDefaultPledgeText(programName);
      }

      if (numValue <= 0) {
        this.programsAmounts[programName] = {
          value: 0,
          usdValue: 0,
          pledgeText: "",
          isSelected: false
        };
      } else {
        this.programsAmounts[programName] = {
          value: numValue,
          usdValue: numUsd,
          pledgeText: text,
          isSelected: true
        };
      }

      this.recalculateAndSave();
    }

    recalculateAndSave() {
      let totalValue = 0;
      let totalUsdValue = 0;
      const activePrograms = [];
      const activePledgeTexts = [];
      const programsAmountsStorage = {};

      Object.entries(this.programsAmounts).forEach(([progName, data]) => {
        programsAmountsStorage[progName] = {
          value: String(data.value),
          usdValue: String(data.usdValue),
          pledge_message: data.pledgeText || ""
        };

        if (data.isSelected && data.value > 0) {
          totalValue += data.value;
          totalUsdValue += data.usdValue;
          activePrograms.push(progName);
          if (data.pledgeText) {
            activePledgeTexts.push(`(${this.currencyCode} ${data.value}) ${data.pledgeText}`);
          }
        }
      });

      let combinedPledgeMessage = "";
      if (activePledgeTexts.length === 1) {
        combinedPledgeMessage = activePledgeTexts[0];
      } else if (activePledgeTexts.length > 1) {
        combinedPledgeMessage = activePledgeTexts.join(" and ");
      }

      // Store/update each amount for each program or campaign, then store sum in amounts
      const storageUpdate = {
        ...programsAmountsStorage,
        programs_amounts: programsAmountsStorage,
        selected_programs: activePrograms,
        amounts: {
          value: String(totalValue),
          usdValue: totalUsdValue.toFixed(2)
        },
        pledge_message: combinedPledgeMessage
      };

      this.donationForm.saveFormInStorage(storageUpdate);

      if (this.paymentElement) {
        this.paymentElement.updatePaymentElement(this.donationForm);
      }
      afterAmountUpdate(this.donationForm);
    }

    createCurrencyCallbacks() {
      let otherAmountText = translateText("give.fields.other_amount", this.donationForm.translations);
      this.currencySelector.onValueSelected = (defaultCurrency) => onCurrencySelected(defaultCurrency, this.donationForm);
  
      this.currencySelector.onChange = async (selectedIndex, selectedValue) => {
        const currentValue = this.donationForm.getStorage().currency_code;
        onCurrencySelected(selectedValue, this.donationForm);
        try {
          await updatePledgeAmounts(currentValue, selectedValue, this.handles, this.donationForm, otherAmountText, this.paymentElement);
          this.recalculateAndSave();
        } catch (er) {
          this.currencySelector.selectCurrency.value = currentValue;
          onCurrencySelected(currentValue, this.donationForm);
          console.error(er);
        }
      };
    }
  }